// import React, { useState } from 'react';
// import { useParams } from 'react-router-dom';

// import './PropertyPage.css';
// import Navbar from '../../LandingPage/Navbar';
// import Footer from '../../LandingPage/Footer';

// import s3 from '../../Images/s3.jpg';
// import s4 from '../../Images/s4.jpg';
// import s9 from '../../Images/s9.jpg';
// import far1 from '../../Images/far1.jpg';
// import far2 from '../../Images/far2.jpg';

// const FILTERS = {
//   residential: ['Flats', 'Villas', 'Plots', 'Farmhouses'],
//   commercial: ['Offices', 'Shops', 'Showrooms'],
//   industrial: ['Warehouses', 'Factories'],
//   agricultural: ['Farmlands', 'Plantations'],
//   "rental-income": ['PGs', 'Leased Spaces'],
// };


// const BANNER_IMAGES = {
//   residential: {
//     image: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=1600&q=80',
//     title: 'Residential Properties'
//   },
//   commercial: {
//     image: 'https://images.unsplash.com/photo-1601598851547-4302969d0614',
//     title: 'Commercial Properties'
//   },
//   industrial: {
//     image: 'https://plus.unsplash.com/premium_photo-1682144941342-c220b2bc949e?q=80&w=870&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
//     title: 'Industrial Properties'
//   },
//   agricultural: {
//     image: 'https://images.unsplash.com/photo-1500382017468-9049fed747ef?auto=format&fit=crop&w=1600&q=80',
//     title: 'Agricultural Properties'
//   },
//  "rental-income": {
//     image: 'https://images.unsplash.com/photo-1554995207-c18c203602cb?auto=format&fit=crop&w=1600&q=80',
//     title: 'Rental / Income Properties'
//   },
// };


// const PROPERTIES = [
//   /* ================= RESIDENTIAL ================= */
//   {
//     id: 1,
//     type: 'residential',
//     category: 'Flats',
//     name: 'Luxury Sky Apartments',
//     location: 'Uppal, Hyderabad',
//     image: 'https://images.unsplash.com/photo-1560448204-e02f11c3d0e2'
//   },
//   {
//     id: 2,
//     type: 'residential',
//     category: 'Villas',
//     name: 'Royal Garden Villas',
//     location: 'Gachibowli',
//     image: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c'
//   },
//   {
//     id: 3,
//     type: 'residential',
//     category: 'Plots',
//     name: 'Premium Residential Plots',
//     location: 'Shamirpet',
//     image: 'https://images.unsplash.com/photo-1501183638710-841dd1904471'
//   },
//   {
//     id: 4,
//     type: 'residential',
//     category: 'Farmhouses',
//     name: 'Green Valley Farmhouses',
//     location: 'Moinabad',
// image: 'https://images.unsplash.com/photo-1600047509807-ba8f99d2cdde?auto=format&fit=crop&w=1200&q=80'



//   },

//   /* ================= COMMERCIAL ================= */
//   {
//     id: 5,
//     type: 'commercial',
//     category: 'Offices',
//     name: 'IT Corporate Office Space',
//     location: 'Hitech City',
//     image: 'https://images.unsplash.com/photo-1497366216548-37526070297c'
//   },
//   {
//     id: 6,
//     type: 'commercial',
//     category: 'Shops',
//     name: 'High-Street Retail Shops',
//     location: 'Jubilee Hills',
//     image: 'https://images.unsplash.com/photo-1601598851547-4302969d0614'
//   },
// //   {
// //     id: 7,
// //     type: 'commercial',
// //     category: 'Showrooms',
// //     name: 'Luxury Auto Showroom',
// //     location: 'Banjara Hills',
// // image: 'https://images.unsplash.com/photo-1542362567-b07e54358753?auto=format&fit=crop&w=1200&q=80'






// //   },
//   {
//     id: 8,
//     type: 'commercial',
//     category: 'Offices',
//     name: 'Business Tower Offices',
//     location: 'Financial District',
// image: 'https://images.unsplash.com/photo-1497366754035-f200968a6e72?auto=format&fit=crop&w=1200&q=80'

//   },

//   /* ================= INDUSTRIAL ================= */
//   {
//     id: 9,
//     type: 'industrial',
//     category: 'Warehouses',
//     name: 'Logistics Warehouse Hub',
//     location: 'Shadnagar',
//     image: 'https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d'
//   },
//   {
//     id: 10,
//     type: 'industrial',
//     category: 'Factories',
//     name: 'Manufacturing Facility',
//     location: 'Patancheru',
//  image: 'https://plus.unsplash.com/premium_photo-1682144941342-c220b2bc949e?q=80&w=870&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D'


//   },
//   {
//     id: 11,
//     type: 'industrial',
//     category: 'Warehouses',
//     name: 'Cold Storage Warehouse',
//     location: 'Medchal',
// image: 'https://plus.unsplash.com/premium_photo-1661914966293-c129661d4915?q=80&w=870&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D'

//   },
//   {
//     id: 12,
//     type: 'industrial',
//     category: 'Factories',
//     name: 'Industrial Production Unit',
//     location: 'Jeedimetla',
//    image: 'https://images.unsplash.com/photo-1581092580497-e0d23cbdf1dc?auto=format&fit=crop&w=1200&q=80'

//   },

//   /* ================= AGRICULTURAL ================= */
//   {
//     id: 13,
//     type: 'agricultural',
//     category: 'Farmlands',
//     name: 'Fertile Farmland Acres',
//     location: 'Chevella',
//     image: s3
//   },
//   {
//     id: 14,
//     type: 'agricultural',
//     category: 'Plantations',
//     name: 'Organic Mango Plantation',
//     location: 'Vikarabad',
//     image:s4
//   },
//   {
//     id: 15,
//     type: 'agricultural',
//     category: 'Farmlands',
//     name: 'River View Agricultural Land',
//     location: 'Sangareddy',
//     image: 'https://images.unsplash.com/photo-1500382017468-9049fed747ef'
//   },
//   {
//     id: 16,
//     type: 'agricultural',
//     category: 'Plantations',
//     name: 'Teakwood Plantation Estate',
//     location: 'Mahbubnagar',
//     image: far2
//   },

//   /* ================= RENTAL / INCOME ================= */
//   {
//     id: 17,
//     type: 'rental-income',
//     category: 'PGs',
//     name: 'Premium Men’s PG',
//     location: 'Madhapur',
//     image: 'https://images.unsplash.com/photo-1554995207-c18c203602cb'
//   },
//   {
//     id: 18,
//     type: 'rental-income',
//     category: 'PGs',
//     name: 'Luxury Women’s PG',
//     location: 'Kondapur',
//     image: 'https://images.unsplash.com/photo-1598928506311-c55ded91a20c'
//   },
//   {
//     id: 19,
//     type: 'rental-income',
//     category: 'Leased Spaces',
//     name: 'Long-Term Leased Office',
//     location: 'Begumpet',
//     image: 'https://images.unsplash.com/photo-1497215728101-856f4ea42174'
//   },
//   {
//     id: 20,
//     type: 'rental-income',
//     category: 'Leased Spaces',
//     name: 'Retail Space – Guaranteed Returns',
//     location: 'Ameerpet',
//     image: 'https://images.unsplash.com/photo-1600585154526-990dced4db0d'
//   }
// ];


// // const PropertyPage = () => {
// //   const { type } = useParams();
// //   const [selectedFilters, setSelectedFilters] = useState([]);

// //   const toggleFilter = (item) => {
// //     setSelectedFilters(prev =>
// //       prev.includes(item) ? prev.filter(f => f !== item) : [...prev, item]
// //     );
// //   };

// //   const filteredProperties = PROPERTIES.filter(
// //     p =>
// //       p.type === type &&
// //       (selectedFilters.length === 0 || selectedFilters.includes(p.category))
// //   );

// //   return (
// //     <>
// //       <Navbar />

// //       <section className="property-page">
// //         <div className="property-layout">

// //           {/* Left Filters */}
// //           <aside className="filters">
// //             <h4>Filter</h4>
// //             {FILTERS[type]?.map(item => (
// //               <label key={item} className="checkbox">
// //                 <input
// //                   type="checkbox"
// //                   onChange={() => toggleFilter(item)}
// //                 />
// //                 <span>{item}</span>
// //               </label>
// //             ))}
// //           </aside>

// //           {/* Right Grid */}
// //           <div className="property-grid">
// //             {filteredProperties.map(p => (
// //               <div key={p.id} className="property-card">
// //                 <img src={p.image} alt={p.name} />
// //                 <div className="card-content">
// //                   <h3>{p.name}</h3>
// //                   <p>{p.location}</p>
// //                 </div>
// //               </div>
// //             ))}
// //           </div>

// //         </div>
// //       </section>

// //       <Footer />
// //     </>
// //   );
// // };

// const PropertyPage = () => {
//   const { type } = useParams();
//   const [selectedFilters, setSelectedFilters] = useState([]);

//   const toggleFilter = (item) => {
//     setSelectedFilters(prev =>
//       prev.includes(item) ? prev.filter(f => f !== item) : [...prev, item]
//     );
//   };

//   const filteredProperties = PROPERTIES.filter(
//     p =>
//       p.type === type &&
//       (selectedFilters.length === 0 || selectedFilters.includes(p.category))
//   );

//   const banner = BANNER_IMAGES[type];

//   return (
//     <>
//       <Navbar transparent /> {/* Pass transparent prop for transparent overlay */}

//       {/* --- Banner Section --- */}
      // <section 
      //   className="property-banner" 
      //   style={{ backgroundImage: `url(${banner?.image})` }}
      // >
      //   <div className="banner-overlay">
      //     <h1>{banner?.title}</h1>
      //   </div>
      // </section>

//       {/* --- Property Filters & Grid --- */}
//       <section className="property-page">
//         <div className="property-layout">

//           {/* Left Filters */}
//           <aside className="filters">
//             <h4>Filter</h4>
//             {FILTERS[type]?.map(item => (
//               <label key={item} className="checkbox">
//                 <input
//                   type="checkbox"
//                   onChange={() => toggleFilter(item)}
//                 />
//                 <span>{item}</span>
//               </label>
//             ))}
//           </aside>

//           {/* Right Grid */}
//           <div className="property-grid">
//             {filteredProperties.map(p => (
//               <div key={p.id} className="property-card">
//                 <img src={p.image} alt={p.name} />
//                 <div className="card-content">
//                   <h3>{p.name}</h3>
//                   <p>{p.location}</p>
//                 </div>
//               </div>
//             ))}
//           </div>

//         </div>
//       </section>

//       <Footer />
//     </>
//   );
// };


// export default PropertyPage;

// import React, { useState, useEffect } from 'react';
// import { useParams } from 'react-router-dom';
// import './PropertyPage.css';
// import Navbar from '../../LandingPage/Navbar';
// import Footer from '../../LandingPage/Footer';
// import axios from "axios";

// import { useNavigate } from "react-router-dom";

// // const BANNER_IMAGES = {
// //   residential: {
// //     image: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=1600&q=80',
// //     title: 'Residential Properties'
// //   },
// //   commercial: {
// //     image: 'https://images.unsplash.com/photo-1601598851547-4302969d0614',
// //     title: 'Commercial Properties'
// //   },
// //   industrial: {
// //     image: 'https://plus.unsplash.com/premium_photo-1682144941342-c220b2bc949e?q=80&w=870&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
// //     title: 'Industrial Properties'
// //   },
// //   agricultural: {
// //     image: 'https://images.unsplash.com/photo-1500382017468-9049fed747ef?auto=format&fit=crop&w=1600&q=80',
// //     title: 'Agricultural Properties'
// //   },
// //  "rental-income": {
// //     image: 'https://images.unsplash.com/photo-1554995207-c18c203602cb?auto=format&fit=crop&w=1600&q=80',
// //     title: 'Rental / Income Properties'
// //   },
// // };



// // const PropertyPage = () => {
// //   const { type } = useParams();
// //   const [filters, setFilters] = useState([]);
// //   const [selectedFilters, setSelectedFilters] = useState([]);
// //   const [properties, setProperties] = useState([]);

// //   // Fetch filters dynamically
// //   useEffect(() => {
// //     fetch('https://api.propertygalleria.in/api/property-filters')
// //       .then(res => res.json())
// //       .then(data => setFilters(data[type] || []))
// //       .catch(err => console.error(err));
// //   }, [type]);

// //   // Fetch all properties
// //   useEffect(() => {
// //     // fetch('https://api.propertygalleria.in/api/properties/full')
// //      fetch('https://api.propertygalleria.in/master/api/api/owner/properties')
    
// //       .then(res => res.json())
// //       .then(data => setProperties(data))
// //       .catch(err => console.error(err));
// //   }, []);

// //   const toggleFilter = (item) => {
// //     setSelectedFilters(prev =>
// //       prev.includes(item) ? prev.filter(f => f !== item) : [...prev, item]
// //     );
// //   };

// // // Filter properties by selected category and filters
// // const filteredProperties = properties
// //   .filter(p => p.category_name.toLowerCase() === type.toLowerCase())
// //   .filter(p => selectedFilters.length === 0 || selectedFilters.includes(p.type_name));


// // const banner = BANNER_IMAGES[type];


// //   return (
// //     <>
// //       <Navbar transparent />

// //       {/* Banner */}
// //       <section 
// //         className="property-banner" 
// //         style={{ backgroundImage: `url(${banner?.image})` }}
// //       >
// //         <div className="banner-overlay">
// //           <h1>{banner?.title}</h1>
// //         </div>
// //       </section>

// //       {/* Page Layout */}
// //       <section className="property-page">
// //         <div className="property-layout">

// //           {/* Filters */}
// //           <aside className="filters">
// //             <h4>Filter</h4>
// //             {filters.map(item => (
// //               <label key={item} className="checkbox">
// //                 <input
// //                   type="checkbox"
// //                   onChange={() => toggleFilter(item)}
// //                 />
// //                 <span>{item}</span>
// //               </label>
// //             ))}
// //           </aside>

// //           {/* Properties Grid */}
// //           <div className="property-grid">
// //             {filteredProperties.map(p => (
// //               <div key={p.id} className="property-card">
// //                 <img src={p.image} alt={p.property_name} />
// //                 <div className="card-content">
// //                   <h3>{p.property_name}</h3>
// //                   <p>{p.location}</p>
// //                 </div>
// //               </div>
// //             ))}
// //           </div>

// //         </div>
// //       </section>

// //       <Footer />
// //     </>
// //   );
// // };

// // export default PropertyPage;

// const PropertyPage = () => {
// const { type } = useParams();

//     const [categories, setCategories] = useState([]);
//     const [properties, setProperties] = useState([]);
//     const [filtered, setFiltered] = useState([]);

//     const [selectedCategory, setSelectedCategory] = useState("All");
//     const [search, setSearch] = useState("");
//     const [price, setPrice] = useState(10000000);
//     const [maxPrice, setMaxPrice] = useState(10000000);

//     const [highways, setHighways] = useState([]);
//     const [selectedHighway, setSelectedHighway] = useState("All");
//     const [sortOrder, setSortOrder] = useState("default");

//     const [filterOpen, setFilterOpen] = useState(false);

//     useEffect(() => {
//     if (type) {
//         setSelectedCategory(type);
        
//     }
// }, [type]);

//     /* ---------------- FETCH DATA ---------------- */

//     useEffect(() => {
//         fetchData();
//     }, []);

//     // const fetchData = async () => {

//     //     try {

//     //         const [catRes, propRes] = await Promise.all([
//     //             axios.get("https://api.propertygalleria.in/api/property-categories"),
//     //             axios.get("https://api.propertygalleria.in/master/api/api/owner/properties")
//     //         ]);
//     //         const props = propRes.data.data;
//     //         setCategories(catRes.data);
//     //         // setProperties(propRes.data.data);
//     //         // setFiltered(propRes.data.data);
//     //         setProperties(props);
//     //         setFiltered(props);

//     //         /* GET UNIQUE HIGHWAYS */

//     //         const uniqueHighways = [
//     //             ...new Set(props.map(p => p.zone_desc).filter(Boolean))
//     //         ];

//     //         setHighways(uniqueHighways);

//     //         const highest = Math.max(
//     //             ...props.map(p => parseInt(p.price) || 0)
//     //         );

//     //         setMaxPrice(highest);
//     //         setPrice(highest);


//     //     } catch (err) {
//     //         console.log(err);
//     //     }

//     // };

// //     useEffect(() => {
// //     if (location.state?.highway) {
// //         setSelectedHighway(location.state.highway);
// //     }
// // }, [location.state]);



//     const fetchData = async () => {
//     try {

//         const [catRes, propRes, zoneRes] = await Promise.all([
//             axios.get("https://api.propertygalleria.in/api/property-categories"),
//             axios.get("https://api.propertygalleria.in/master/api/api/owner/properties"),
//             axios.get("https://api.propertygalleria.in/master/api/api/zones") // 🔥 YOUR API
//         ]);

//         const props = propRes.data.data;

//         setCategories(catRes.data);
//         setProperties(props);
//         setFiltered(props);

//         // ✅ SET HIGHWAYS FROM ZONE API
//         const zoneList = zoneRes.data.map(z => z.zone_desc);

//         setHighways(zoneList);

//         // price logic
//         const highest = Math.max(
//             ...props.map(p => parseInt(p.price) || 0)
//         );

//         setMaxPrice(highest);
//         setPrice(highest);

//     } catch (err) {
//         console.log(err);
//     }
// };
//     const formatPrice = (num) => {

//         if (num >= 10000000) {
//             return (num / 10000000).toFixed(1).replace(".0", "") + "Cr";
//         }

//         if (num >= 100000) {
//             return (num / 100000).toFixed(1).replace(".0", "") + "L";
//         }

//         if (num >= 1000) {
//             return (num / 1000).toFixed(1).replace(".0", "") + "K";
//         }

//         return num;
//     };

//     /* ---------------- FILTER LOGIC ---------------- */

//     // useEffect(() => {

//     //     let data = [...properties];

//     //     if (selectedCategory !== "All") {
//     //         data = data.filter(
//     //             p => p.category?.toLowerCase() === selectedCategory.toLowerCase()
//     //         );
//     //     }

//     //     if (search) {
//     //         data = data.filter(
//     //             p => p.title?.toLowerCase().includes(search.toLowerCase())
//     //         );
//     //     }

//     //     data = data.filter(p => parseInt(p.price) <= price);

//     //     setFiltered(data);

//     // }, [selectedCategory, search, price, properties]);
// const toSlug = (value = '') =>
//   value
//     .toLowerCase()
//     .trim()
//     .replace(/\s*\/\s*/g, '-')
//     .replace(/\s+/g, '-');

//     useEffect(() => {

//         let data = [...properties];

//         /* CATEGORY FILTER */

//         // if (selectedCategory !== "All") {
//         //     data = data.filter(
//         //         p => p.category?.toLowerCase() === selectedCategory.toLowerCase()
//         //     );
//         // }
//         // if (selectedCategory !== "All") {
//         //          data = data.filter(
//         //        p =>
//         //     //p.category?.toLowerCase().trim() === selectedCategory.toLowerCase().trim()
//         //    toSlug(p.category) === selectedCategory
//         //       );
//         //  }
//          if (selectedHighway !== "All") {
//             data = data.filter(
//                 p =>
//                     p.zone_desc?.toLowerCase().trim() ===
//                     selectedHighway.toLowerCase().trim()
//             );
//         }

//         /* SEARCH FILTER */

//         if (search) {
//             data = data.filter(
//                 p =>
//                     p.title?.toLowerCase().includes(search.toLowerCase()) ||
//                     p.location?.toLowerCase().includes(search.toLowerCase())
//             );
//         }

//         /* HIGHWAY FILTER */

//         if (selectedHighway !== "All") {
//             data = data.filter(
//                 p =>
//                     // p.zone_desc?.toLowerCase() === selectedHighway.toLowerCase()
//                 p.zone_desc?.toLowerCase().trim() === selectedHighway.toLowerCase().trim()
//             );
//         }

//         /* PRICE FILTER */

//         data = data.filter(
//             p => parseInt(p.price) <= price
//         );

//         /* SORTING */

//         if (sortOrder === "low") {
//             data.sort((a, b) => parseInt(a.price) - parseInt(b.price));
//         }

//         if (sortOrder === "high") {
//             data.sort((a, b) => parseInt(b.price) - parseInt(a.price));
//         }

//         setFiltered(data);

//     }, [
//         selectedCategory,
//         selectedHighway,
//         search,
//         price,
//         sortOrder,
//         properties
//     ]);


//     const navigate = useNavigate();

//     return (
//         <>
//          <Navbar transparent />
//             {/* <Header /> */}

//             {/* ---------------- CATEGORY SCROLL ---------------- */}

//             <div style={categoryBar}
//             >

//                 <button
//                     style={selectedCategory === "All" ? activeCat : catBtn}
//                     onClick={() => setSelectedCategory("All")}
//                 >
//                     All
//                 </button>

//                 {categories.map(cat => (
//                     <button
//                         key={cat.id}
//                         style={
//                             // selectedCategory === cat.category_name
//                             selectedCategory === toSlug(cat.category_name)
//                                 ? activeCat
//                                 : catBtn
//                         }
//                         // onClick={() => setSelectedCategory(cat.category_name)}
//                         onClick={() => setSelectedCategory(toSlug(cat.category_name))}
//                     >
//                         {cat.category_name}
//                     </button>
//                 ))}

//             </div>



//             {/* ---------------- MAIN LAYOUT ---------------- */}

//             <div style={layout}>


//                 {/* ---------------- LEFT FILTERS ---------------- */}

//                 <div style={filterBox}>

//                     <h3 style={{ marginBottom: 20 }}>Filters</h3>

//                     <label>Search</label>

//                     <input
//                         style={input}
//                         placeholder="Search property..."
//                         value={search}
//                         onChange={(e) => setSearch(e.target.value)}
//                     />

//                     <label>Category</label>

//                     <select
//                         style={input}
//                         value={selectedCategory}
//                         onChange={(e) => setSelectedCategory(e.target.value)}
//                     >

//                         <option value="All">All</option>

//                         {categories.map(cat => (
//                             <option key={cat.id}>
//                                 {cat.category_name}
//                             </option>
//                         ))}

//                     </select>

//                     <label>Highway</label>

//                     {/* <select
//                         style={input}
//                         value={selectedHighway}
//                         onChange={(e) => setSelectedHighway(e.target.value)}
//                     >
//                         <option value="All">All</option>

//                         {highways.map((hw, i) => (
//                             <option key={i} value={hw}>
//                                 {hw}
//                             </option>
//                         ))}
//                     </select> */}

//                       <select
//                         style={input}
//                         value={selectedHighway}
//                         onChange={(e) => setSelectedHighway(e.target.value)}
//                     >
//                         <option value="All">All</option>

//                         {highways.map((hw, i) => (
//                             <option key={i} value={hw}>
//                                 {hw}
//                             </option>
//                         ))}
//                     </select>


//                     <label>Price</label>

//                     <input
//                         type="range"
//                         min="0"
//                         max={maxPrice}
//                         value={price}
//                         onChange={(e) => setPrice(Number(e.target.value))}
//                     /> 

//                     <p>
//                         Max Price : ₹ {formatPrice(price)}
//                     </p>
//                     <label style={{marginTop:'10px'}}>Sort By Price</label>

//                     <select
//                         style={input}
//                         value={sortOrder}
//                         onChange={(e) => setSortOrder(e.target.value)}
//                     >
//                         <option value="default">Default</option>
//                         <option value="low">Low → High</option>
//                         <option value="high">High → Low</option>
//                     </select>

//                 </div>


//                 {/* ---------------- PROPERTY GRID ---------------- */}

//                 <div style={propertyGrid}>

//                     {filtered.map(p => (

//                         <div key={p.id} style={card}>

//                             <img
//                                 src={p.image || p.property_images?.[0]}
//                                 alt=""
//                                 style={image}
//                                 onClick={() =>
//                                     navigate(`/properties/${p.id}`, {
//                                         state: { property: p }
//                                     })
//                                 }
//                             />

//                             <div style={{ padding: 15 }}>

//                                 <h3>{p.title}</h3>

//                                 <p style={{ color: "#666" }}>
//                                     📍 {p.location}
//                                 </p>

//                                 <div style={priceRow}>
//                                     <span style={{ color: "#2563eb", fontWeight: "bold" }}>
//                                         {/* ₹ {p.price} */ } ₹ {formatPrice(p.price)}
//                                     </span>

//                                     <span>{p.area} ACRES</span>
//                                 </div>

//                                 <span style={badge}>
//                                     {p.category}
//                                 </span>

//                             </div>

//                         </div>

//                     ))}

//                 </div>


//             </div>


//  <Footer />
//             {/* <Footer/> */}
//         </>
//     );
// };

// export default PropertyPage;

import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import './PropertyPage.css';
import Navbar from '../../LandingPage/Navbar';
import Footer from '../../LandingPage/Footer';
import axios from "axios";

const PropertyPage = () => {

    const { type } = useParams();
    const navigate = useNavigate();

    const [categories, setCategories] = useState([]);
    const [properties, setProperties] = useState([]);
    const [filtered, setFiltered] = useState([]);

    const [selectedCategory, setSelectedCategory] = useState("All");
    const [search, setSearch] = useState("");
    const [price, setPrice] = useState(10000000);
    const [maxPrice, setMaxPrice] = useState(10000000);

    const [highways, setHighways] = useState([]);
    const [selectedHighway, setSelectedHighway] = useState("All");
    const [sortOrder, setSortOrder] = useState("default");

    const [layoutApprovals, setLayoutApprovals] = useState([]);
const [selectedLayoutApproval, setSelectedLayoutApproval] = useState("All");


  const [selectedNearby, setSelectedNearby] = useState("All");
    const [selectedPropertyType, setSelectedPropertyType] = useState("All");

    const nearbyOptions = [
        "IRR Inner Ring Road",
        "ORR Outer Ring Road",
        "RRR Regional Ring Road"
    ];

    const propertyTypeOptions = [
        "Open Plots/Villa Plots",
        "Flats",
        "Villas",
        "Farm Land",
        "Houses"
    ];



    /* ---------------- SLUG FUNCTION ---------------- */
    const toSlug = (value = '') =>
        value
            .toLowerCase()
            .trim()
            .replace(/\s*\/\s*/g, '-')
            .replace(/\s+/g, '-');

    /* ---------------- SET CATEGORY FROM URL ---------------- */
    useEffect(() => {
        if (type) {
            setSelectedCategory(type);
        }
    }, [type]);

    /* ---------------- FETCH DATA ---------------- */
    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        try {
            // const [catRes, propRes, zoneRes] = await Promise.all([
            // const [catRes, propRes, zoneRes, layoutRes] = await Promise.all([
                // axios.get("https://api.propertygalleria.in/api/property-categories"),
                // axios.get("https://api.propertygalleria.in/master/api/api/owner/properties"),
                // axios.get("https://api.propertygalleria.in/master/api/api/zones")
            // ]);
            const [catRes, propRes, zoneRes, layoutRes] = await Promise.all([
axios.get("https://api.propertygalleria.in/api/property-categories"),
                axios.get("https://api.propertygalleria.in/master/api/api/owner/properties"),
                axios.get("https://api.propertygalleria.in/master/api/api/zones"),
    axios.get("https://api.propertygalleria.in/master/api/api/layout-approvals")
]);

            const props = propRes.data.data;

            setCategories(catRes.data);
            setProperties(props);
            setFiltered(props);

            const zoneList = zoneRes.data.map(z => z.zone_desc);
            setHighways(zoneList);
setLayoutApprovals(layoutRes.data.data);
            const highest = Math.max(
                ...props.map(p => parseInt(p.price) || 0)
            );

            setMaxPrice(highest);
            setPrice(highest);

        } catch (err) {
            console.log(err);
        }
    };

    /* ---------------- PRICE FORMAT ---------------- */
    const formatPrice = (num) => {
        if (num >= 10000000) return (num / 10000000).toFixed(1).replace(".0", "") + "Cr";
        if (num >= 100000) return (num / 100000).toFixed(1).replace(".0", "") + "L";
        if (num >= 1000) return (num / 1000).toFixed(1).replace(".0", "") + "K";
        return num;
    };

    /* ---------------- FILTER LOGIC ---------------- */
    useEffect(() => {

        let data = [...properties];

        /* ✅ CATEGORY FILTER (FIXED) */
        if (selectedCategory !== "All") {
            data = data.filter(
                p => toSlug(p.category) === selectedCategory
            );
        }

        /* SEARCH */
        if (search) {
            data = data.filter(
                p =>
                    p.title?.toLowerCase().includes(search.toLowerCase()) ||
                    p.location?.toLowerCase().includes(search.toLowerCase())
            );
        }

        /* HIGHWAY */
        if (selectedHighway !== "All") {
            data = data.filter(
                p =>
                    p.zone_desc?.toLowerCase().trim() ===
                    selectedHighway.toLowerCase().trim()
            );
        }

                  /* NEARBY FILTER */
        if (selectedNearby !== "All") {
            data = data.filter(
                p =>
                    p.nearby?.toLowerCase().trim() ===
                    selectedNearby.toLowerCase().trim()
            );
        }


             /* PROPERTY TYPE FILTER */
        if (selectedPropertyType !== "All") {
            data = data.filter(
                p =>
                    p.property_type?.toLowerCase().trim() ===
                    selectedPropertyType.toLowerCase().trim()
            );
        }
        /* LAYOUT APPROVAL */
if (selectedLayoutApproval !== "All") {
    data = data.filter(
        p =>
            p.layout_approval?.toLowerCase().trim() ===
            selectedLayoutApproval.toLowerCase().trim()
    );
}

        /* PRICE */
        data = data.filter(p => (parseInt(p.price) || 0) <= price);

        /* SORT */
        if (sortOrder === "low") {
            data.sort((a, b) => (parseInt(a.price) || 0) - (parseInt(b.price) || 0));
        }

        if (sortOrder === "high") {
            data.sort((a, b) => (parseInt(b.price) || 0) - (parseInt(a.price) || 0));
        }

        setFiltered(data);

    // }, [selectedCategory, selectedHighway, search, price, sortOrder, properties]);
    //}, [selectedCategory, selectedHighway, selectedLayoutApproval, search, price, sortOrder, properties]);
}, [
        // selectedCategory,
        // selectedHighway,
        // selectedLayoutApproval,
        // search,
        // price,
        // sortOrder,
        // properties
           selectedCategory,
        selectedHighway,
        selectedNearby,
        selectedPropertyType,
        selectedLayoutApproval,
        search,
        price,
        sortOrder,
        properties
    ]);
    return (
        <>
            <Navbar transparent />

            {/* CATEGORY BAR */}
            <div style={categoryBar}>

                <button
                    style={selectedCategory === "All" ? activeCat : catBtn}
                    onClick={() => setSelectedCategory("All")}
                >
                    All
                </button>

                {categories.map(cat => (
                    <button
                        key={cat.id}
                        style={
                            selectedCategory === toSlug(cat.category_name)
                                ? activeCat
                                : catBtn
                        }
                        onClick={() => setSelectedCategory(toSlug(cat.category_name))}
                    >
                        {cat.category_name}
                    </button>
                ))}

            </div>

            {/* MAIN */}
            <div style={layout}>

                {/* FILTERS */}
                <div style={filterBox}>

                    <h3>Filters</h3>

                    <input
                        style={input}
                        placeholder="Search property..."
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                    />

                    {/* ✅ FIXED DROPDOWN */}
                    <select
                        style={input}
                        value={selectedCategory}
                        onChange={(e) => setSelectedCategory(e.target.value)}
                    >
                        <option value="All">All</option>

                        {categories.map(cat => (
                            <option
                                key={cat.id}
                                value={toSlug(cat.category_name)}
                            >
                                {cat.category_name}
                            </option>
                        ))}
                    </select>

                    {/* HIGHWAY */}
                    <select
                        style={input}
                        value={selectedHighway}
                        onChange={(e) => setSelectedHighway(e.target.value)}
                    >
                        <option value="All">All</option>

                        {highways.map((hw, i) => (
                            <option key={i} value={hw}>{hw}</option>
                        ))}
                    </select>

                               {/* NEAR BY */}
                    <select
                        style={input}
                        value={selectedNearby}
                        onChange={(e) => setSelectedNearby(e.target.value)}
                    >
                        <option value="All">Select Ring Road</option>

                        <option value="IRR Inner Ring Road">
                            IRR Inner Ring Road
                        </option>

                        <option value="ORR Outer Ring Road">
                            ORR Outer Ring Road
                        </option>

                        <option value="RRR Regional Ring Road">
                            RRR Regional Ring Road
                        </option>
                    </select>
                    {/* PROPERTY TYPE */}
                    <select
                        style={input}
                        value={selectedPropertyType}
                        onChange={(e) => setSelectedPropertyType(e.target.value)}
                    >
                        <option value="All">Select Property Type</option>

                        <option value="Open Plots/Villa Plots">
                            Open Plots/Villa Plots
                        </option>

                        <option value="Flats">
                            Flats
                        </option>

                        <option value="Villas">
                            Villas
                        </option>

                        <option value="Farm Land">
                            Farm Land
                        </option>

                        <option value="Houses">
                            Houses
                        </option>
                    </select>

                    {/* LAYOUT APPROVAL */}
<select
    style={input}
    value={selectedLayoutApproval}
    onChange={(e) => setSelectedLayoutApproval(e.target.value)}
>
    <option value="All">All Layouts</option>

    {layoutApprovals.map((layout) => (
        <option
            key={layout.id}
            value={layout.approval_name}
        >
            {layout.approval_name}
        </option>
    ))}
</select>

                    {/* PRICE */}
                    <input
                        type="range"
                        min="0"
                        max={maxPrice}
                        value={price}
                        onChange={(e) => setPrice(Number(e.target.value))}
                    />

                    <p>Max Price : ₹ {formatPrice(price)}</p>

                    {/* SORT */}
                    <select
                        style={input}
                        value={sortOrder}
                        onChange={(e) => setSortOrder(e.target.value)}
                    >
                        <option value="default">Default</option>
                        <option value="low">Low → High</option>
                        <option value="high">High → Low</option>
                    </select>

                </div>

                {/* GRID */}
                <div style={propertyGrid}>

                    {filtered.map(p => (
                        <div key={p.id} style={card}>

                            <img
                                src={p.image || p.property_images?.[0]}
                                alt=""
                                style={image}
                                onClick={() =>
                                    navigate(`/properties/${p.id}`, {
                                        state: { property: p }
                                    })
                                }
                            />

                            <div style={{ padding: 15 }}>
                                <h3>{p.title}</h3>
                                <p>📍 {p.location}</p>

                                <div style={priceRow}>
                                    <span style={{ color: "#2563eb", fontWeight: "bold" }}>
                                        ₹ {formatPrice(p.price)}
                                    </span>
                                    <span>{p.area} ACRES</span>
                                </div>

                                <span style={badge}>{p.category}</span>
                            </div>

                        </div>
                    ))}

                </div>

            </div>

            <Footer />
        </>
    );
};

export default PropertyPage;

/* ---------------- STYLES ---------------- */

const layout = {
    display: "flex",
    gap: 30,
    padding: "30px",
    alignItems: "flex-start"
};

const filterBox = {
    width: "260px",
    background: "#fff",
    padding: 20,
    borderRadius: 12,
    boxShadow: "0 5px 20px rgba(0,0,0,0.08)",
    position: "sticky",
    top: 100
};

const propertyGrid = {
    flex: 1,
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill,minmax(280px,1fr))",
    gap: 20
};

const card = {
    background: "#fff",
    borderRadius: 16,
    overflow: "hidden",
    boxShadow: "0 10px 25px rgba(0,0,0,0.08)",
    transition: "0.3s"
};

const image = {
    width: "100%",
    height: 180,
    objectFit: "contain"
};

const categoryBar = {
    display: "flex",
    gap: 10,
    overflowX: "auto",
    padding: "20px 30px",
    borderBottom: "1px solid #eee",
    marginTop:'9%',
};

const catBtn = {
    padding: "8px 18px",
    borderRadius: 20,
    border: "1px solid #ddd",
    background: "#fff",
    cursor: "pointer",
    whiteSpace: "nowrap"
};

const activeCat = {
    ...catBtn,
    background: "#2563eb",
    color: "#fff",
    border: "none"
};

const input = {
    width: "100%",
    padding: "10px",
    marginTop: 5,
    marginBottom: 15,
    borderRadius: 8,
    border: "1px solid #ddd"
};

const priceRow = {
    display: "flex",
    justifyContent: "space-between",
    marginTop: 10
};

const badge = {
    marginTop: 10,
    display: "inline-block",
    background: "#e0ecff",
    color: "#2563eb",
    padding: "6px 12px",
    borderRadius: 20,
    fontSize: 12
};